import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { KycMarutiService } from './kyc-link-results.service';
import { HypervergeTokenRes } from './kyc-maruti-model';
import { ActivatedRoute, Params } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-kyc-maruti',
  templateUrl: './kyc-maruti.component.html',
  styleUrls: ['./kyc-maruti.component.css']
})
export class KycMarutiComponent implements OnInit {

  isLoading: boolean;
  flowType: string;
  kycUniqueId: string;
  currentDate: Date;
  accessToken: string;
  error: string;
  kycDetails: any;
  urlType: string;
  identifier: string;
  linkDetails: any;
  customerType: string;
  appName: string;
  returnUrl: string;
  empCode: string;
  empName: string;
  empDesignation: string;
  panValue: string;
  //panMadatory: boolean = false;
  form60: string;
  isExternalUser: string;
  customerName: string;

  private unsubscriber: Subject<void> = new Subject<void>();

  constructor(private renderer2: Renderer2, @Inject(DOCUMENT) private _document, private kycMarutiService: KycMarutiService, private route: ActivatedRoute, private location: LocationStrategy) {
  }

  ngOnInit(): void {
    history.pushState(null, '');

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
    this.route.queryParams.subscribe(
      (params: Params) => {
        /*if (params['mi_unique_identifier']) {
          this.kycUniqueId = params['mi_unique_identifier'];
        }
        if (params['url_type']) {
          this.urlType = params['url_type'];
        }*/
        if (params['identifier']) {
          this.identifier = atob(params['identifier']);
        }
      }
    );
    if(this.identifier) {
      this.linkDetails = JSON.parse(this.identifier);
      this.kycUniqueId = this.linkDetails.uniqueId;
      this.urlType = this.linkDetails.urlType;
      this.customerType = this.linkDetails.customerType;
      this.appName = this.linkDetails.appName;
      this.returnUrl = this.linkDetails.returnUrl;
      this.empCode = this.linkDetails.empCode;
      this.empName = this.linkDetails.empName;
      this.empDesignation = this.linkDetails.empDesignation;
      this.panValue = this.linkDetails.panNo;
      this.form60 = this.linkDetails.form60;
      this.customerName = this.linkDetails.customerName;
      this.isExternalUser = this.linkDetails.isExternalUser;
    }
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = "https://hv-camera-web-sg.s3-ap-southeast-1.amazonaws.com/hyperverge-web-sdk@5.6.0/src/sdk.min.js";
    s.text = ``;
    this.renderer2.appendChild(this._document.body, s);
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  startKyc(value) {
    this.kycDetails = null;
    if (!this.kycUniqueId) {
      this.getUniqueId();
    }
    this.flowType = value;
    this.getKycHypervergeToken();
  }

  getKycHypervergeToken() {
    this.error = '';
    this.isLoading = true;
    this.kycMarutiService.generateKycHypervergeToken().subscribe((data: HypervergeTokenRes) => {
      this.isLoading = false;
      if (data.errMsg) {
        this.error = data.errMsg;
      } else {
        this.accessToken = data.token;
        this.hvWebFaceMatch();
      }
    });
  }

  hvWebFaceMatch = async () => {
    const hyperKycConfig = new (<any>window).HyperKycConfig(
      this.accessToken,
      this.flowType,
      this.kycUniqueId
    );
    let panOrForm60;
    const kycDate = new Date().toISOString().slice(0, 10).split('-').reverse().join('-');
    if (this.panValue && this.panValue.length) panOrForm60 = this.panValue; else panOrForm60 = 'Form60';
    const sdkInputs = {
      date: kycDate,
      empName: this.empName,
      empCode: this.empCode,
      empDesignation: this.empDesignation,
      panOrForm60,
      name: this.customerName ? this.customerName : "NA"
    };
    hyperKycConfig.setInputs(sdkInputs);
    const handler = (HyperKycResult: any) => {
      console.log(HyperKycResult);
      this.kycDetails = HyperKycResult;
      if(this.returnUrl && this.kycDetails && (this.kycDetails.status == 'auto_approved' || this.kycDetails.status == 'manually_approved' || this.kycDetails.status == 'success' || this.kycDetails.status == 'Success' || this.kycDetails.status == 'needs_review' || this.kycDetails.status == 'kyc_in_progress')) {
        setTimeout(() => {
          this.isLoading = true;
          window.location.href = this.returnUrl;
        }, 3000);
      }
    };
    (<any>window).HyperKYCModule.launch(hyperKycConfig, handler);
    return new Promise((resolve, reject) => {
      const faceCaptureCallback = (HVError: any, HVResponse: any) => {
        // compare image
        console.log(HVError, HVResponse);

        if (HVError) {
          console.log(HVError);
          const errorMessage = HVError.getErrorMessage();
          reject(errorMessage);
        } else if (HVResponse) {
          const apiResults: any = HVResponse.getApiResult();

          const responseData: any = {
            face_match: apiResults.result.match,
            face_match_Response: JSON.stringify(apiResults),
          };
          responseData.logRes = apiResults;
          resolve(responseData);
        }
      };
    });
  }

  getUniqueId() {
    this.currentDate = new Date();
    this.kycUniqueId = "MI" + this.currentDate.getFullYear().toString() + this.currentDate.getMonth().toString() + this.currentDate.getDate().toString() + this.currentDate.getHours().toString() + this.currentDate.getMinutes().toString() + this.currentDate.getSeconds().toString() + this.currentDate.getMilliseconds().toString();
  }

  goToBackPage() {
    this.isLoading = true;
    window.location.href = this.returnUrl;
  }

}
